module.exports = __webpack_public_path__ + "static/media/sand_watch.c6262ef3.png";